import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from '../../../assets/img/logo.png';

export function PrivateRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading /* || isAuthorized === null */) {
        return (
            <div className="page page-center">
                <div className="container container-slim py-4">
                    <div className="text-center">
                        <div className="mb-3">
                            <a href="/" className="navbar-brand navbar-brand-autodark">
                                <img src={logo} alt="Logo" width="150" height="auto" />
                            </a>
                        </div>
                        <div className="text-secondary mb-3">En cours de chargement ...</div>
                        <div className="progress progress-sm">
                            <div className="progress-bar progress-bar-indeterminate"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}
